import moment from 'moment'

const fitnessSchema = ({ data, headers }) => {
  const status = data.status.split('_').join(' ')
  return (
    <tr className='text-gray-600'>
      {headers.map((key) => {
        switch (key.toUpperCase()) {
          case 'FULL NAME':
            return <td className='pl-3 pr-5 py-5'>{data.customer_name}</td>

          case 'APPOINTMENT DATE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.date}</span> | <span>{moment(data.time).format('hh:mm A')}</span>
              </td>
            )

          case 'APPOINTMENT STATUS':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>{status === 'received' ? 'completed' : status}</span>
              </td>
            )

          case 'FITNESS CENTER':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{`${data.provider || ''} ${data.provider_city || ''}`}</span>
              </td>
            )

          case 'WORKOUT TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.workout_type}</span>
              </td>
            )
        }
      })}
    </tr>
  )
}

export default fitnessSchema